import { BaseGroupPlaybackControls } from "./BaseGroup.mjs";
class GroupPlaybackControls extends BaseGroupPlaybackControls {
  then(onResolve, onReject) {
    return Promise.all(this.animations).then(onResolve).catch(onReject);
  }
}
export {
  GroupPlaybackControls
};
